import { Cell, CellWithHierarchy } from '@pelckmans/elementis/components/table';
import { TeacherAssignment } from '../api/AssignmentTeacherApi';
import Assignment from './Assignment';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const BASE = 'PAGES.ASSIGNMENTS.SECTION_PLANNED_AND_ONGOING.TABLE.BODY.ASSIGNMENT_DIVISIONS';

export type EndDateCategory = 'TODAY' | 'THIS_WEEK' | 'LATER' | 'LAST_WEEK' | 'LAST_TWO_WEEKS' | 'IN_LAST_MONTH';

type AssignmentDivisionProps = {
  endDateCategory: EndDateCategory;
  assigments: TeacherAssignment[];
  monthAndYear?: string;
};

function AssignmentDivision({ endDateCategory, assigments, monthAndYear }: AssignmentDivisionProps) {
  const [collapsed, setCollapsed] = useState(false);
  const { t } = useTranslation();

  const title = t(`${BASE}.END_DATE.${endDateCategory}`, { monthAndYear });
  const emptyMessage = t(`${BASE}.EMPTY_MESSAGE.${endDateCategory}`);

  const isEmpty = assigments.length === 0;
  const hasOne = assigments.length === 1;

  return (
    <>
      <tr>
        <CellWithHierarchy
          highlighted
          hierarchyProps={{
            level: 0,
            onToggleCollapsed: () => setCollapsed(x => !x),
            collapsed,
            collapseButtonLabelText: t(`${BASE}.COLLAPSE_BUTTON.A11Y_LABEL`),
          }}
          colspan={6}
        >
          <Cell.Text
            title={title}
            subTitleBot={
              hasOne ? t(`${BASE}.ONE_ASSIGNMENT`) : t(`${BASE}.ASSIGNMENTS_COUNT`, { count: assigments.length })
            }
          />
        </CellWithHierarchy>
      </tr>
      {!collapsed && isEmpty && (
        <tr>
          <CellWithHierarchy hierarchyProps={{ level: 1 }} colspan={6}>
            <Cell.Message title={emptyMessage} />
          </CellWithHierarchy>
        </tr>
      )}
      {!collapsed &&
        !isEmpty &&
        assigments.map(assignment => (
          <Assignment
            key={`${assignment.materialId}-${assignment.school.name}-${assignment.group || 'all-groups'}`}
            assignment={assignment}
            endDateCategory={endDateCategory}
          />
        ))}
    </>
  );
}

export default AssignmentDivision;
